import './DisplayItems.css';

export default function DisplayItems({ items, View, center, end, grid }) {
  return (
    <div className="displayItems">
      {grid ? (
        <div
          className={
            'grid gap-1 grid-flow-row grid-cols-1 justify-center sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 ' +
            ((center && 'justify-center') || (end && 'justify-end'))
          }
        >
          {items?.map((item, i) => (
            <div key={i} className="item flex justify-center">
              <View item={item} />
            </div>
          ))}
        </div>
      ) : (
        <div
          className={
            'flex items-center flex-wrap ' +
            ((center && 'justify-center') || (end && 'justify-end'))
          }
        >
          {items?.map((item, i) => (
            <div key={i} className="item">
              <View item={item} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
